import { connect } from 'react-redux'

import MagnifierConfigurator from './configurator'

const mapStateToProps = (state) => {
  const {
    user: {
      preferences
    }
  } = state

  return {
    preferences
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

const MagnifierConfiguratorContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MagnifierConfigurator)

export default MagnifierConfiguratorContainer



// WEBPACK FOOTER //
// ./client/components/magnifier/configuratorContainer.js